import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "Apurba Estate — Real Estate, Digital Land Survey & Documentation in Kolkata";
const DEFAULT_DESC = "Apurba Estate is a Kolkata-region real estate consultancy offering property transactions, RTK GNSS / DGPS / Total Station land survey, land mutation and documentation support across South 24 Parganas.";
const SITE_URL = "https://estate-consultancy-1.preview.emergentagent.com";
const OG_IMAGE = "https://images.unsplash.com/photo-1773470920361-4f6cbb702ce0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

export default function SEO({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image = OG_IMAGE,
  keywords,
  type = "website",
  jsonLd,
}) {
  const fullTitle = title ? `${title} · Apurba Estate` : DEFAULT_TITLE;
  const canonical = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Apurba Estate" />
      <meta property="og:locale" content="en_IN" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {/* Robots */}
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <meta name="theme-color" content="#101827" />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}

export const LOCAL_BUSINESS_JSONLD = {
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  name: "Apurba Estate",
  url: SITE_URL,
  image: OG_IMAGE,
  description: DEFAULT_DESC,
  areaServed: [
    { "@type": "City", name: "Kolkata" },
    { "@type": "AdministrativeArea", name: "South 24 Parganas" },
  ],
  address: {
    "@type": "PostalAddress",
    addressRegion: "West Bengal",
    addressCountry: "IN",
  },
  priceRange: "₹₹",
  sameAs: [],
};
